import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Typography,
  Card,
  Collapse,
  Spin
} from "antd";
import { useNavigate } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import appStatic from "../../../../config/appStatic";
import appLabel from "../../../../config/appLabel";
import LoanProductForm from "./LoanProductForm";

const { Title } = Typography;

const NewPRD0200 = (props) => {
  //DECLARED VARIABLES

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  
  function onCancel() {
    navigate("/prd0200", { replace: false });
  }

    function backOnClick() {
    navigate("/prd0200", { replace: true });
    
  }

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent pageTitle={appLabel.newLoanProduct} pageItems={appStatic.NewLoanProductItems} />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <LoanProductForm />

        </Card>
      </Spin>
    </MainLayout>
  );
};

export default NewPRD0200;

